import {
  getAddAccountSuccessRedirectionPath,
  removeParamAndFetchUrl
} from '../../connector-form/utils/authorisedAccount';
import { AUTH_ERROR_MESSAGE_PARAM_NAME } from '../../auth-select/constants';
import { ConnectorAuthTypeEnum } from '../../connector-form/interfaces/authType';
import AuthAPI from '../../../auth/api/AuthAPI';

export const fetchAuthorisedAccounts = (
  authType,
  provider,
  router,
  abortController: AbortController
): Promise<{ tokens: any[]; urls?: any }> => {
  if (authType === ConnectorAuthTypeEnum.OAUTH) {
    return AuthAPI.getAuthTokens(
      provider.type,
      getAddAccountSuccessRedirectionPath(router),
      removeParamAndFetchUrl(router, AUTH_ERROR_MESSAGE_PARAM_NAME),
      {
        signal: abortController.signal
      }
    ).then(res => ({
      tokens: res?.data?.tokens,
      urls: res?.data?.urls
    }));
  }

  if (authType === ConnectorAuthTypeEnum.SERVICE) {
    return AuthAPI.fetchServiceAccounts(provider.type, {
      signal: abortController.signal
    }).then(res => ({
      tokens: res?.data
    }));
  }

  return Promise.reject(new Error('unknown auth type'));
};
